<template>
  <section class="">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
    <DataTable :value="warehouseLists" :paginator="true" :rows="10" :filters="filters"
               class="p-datatable-responsive p-datatable-gridlines" data-key="id">
      <Column header="S.n" field="">
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Group" field="groupName"
              filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['groupName']"/>
        </template>
      </Column>
      <Column header="Name" field="name"
              filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
        </template>
      </Column>
      <Column header="Location" field="location"
              filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['location']"/>
        </template>
      </Column>

      <Column header="Status" field="status"
              filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['status']"/>
        </template>
      </Column>
      <Column header="Action" style="width: 20%;">
        <template #empty>No record found</template>
        <template #body="slotProps">
          &nbsp;
          <Button class="p-button-raised p-button-success" icon="pi pi-pencil"
                  @click.prevent="editWarehouse(slotProps.data)"/>
          <Button class="p-button-raised p-button-danger" icon="pi pi-trash"
                  @click.prevent="openDialog(slotProps.data.id)"/>
        </template>
      </Column>
    </Datatable>
      </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteWarehouse"/>
    </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'warehouseList',
  data() {
    return {
      message: '',
      show: false,
      dialogShow: false,
      warehouseId: null,
      filters: {}
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseLists
    }
  },
  mounted() {
    this.warehouseList()
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseList')
    },
    async deleteWarehouse(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        warehouseId: this.warehouseId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteWarehouse', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    editWarehouse(data) {
      this.$emit('edit-warehouse', data)
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.warehouseId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// warehouseList.vue?151095d6